document.addEventListener('DOMContentLoaded', function () {
  if (!document.body.matches('[class*="template-product-raffle"]')) return;

  var selector = 'body[class*="template-product-raffle"] .product-info-details button.shopify-payment-button__button.shopify-payment-button__button--unbranded';

  function changeText() {
    document.querySelectorAll(selector).forEach(function (btn) {
      if (btn.innerHTML !== 'ENTRY RAFFLE NOW') btn.innerHTML = 'ENTRY RAFFLE NOW';
    });
  }

  changeText();

  var observer = new MutationObserver(changeText);
  observer.observe(document.body, { childList: true, subtree: true });
});

document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('.section-slideshow').forEach(section => {
        section.querySelectorAll('.slideshow--content').forEach(content => {
            const button = content.querySelector('.slideshow--button a.button');

            if (!button) return;

            // Hide the original button
            // button.classList.add('hidden');

            // Create overlay link
            const overlayLink = document.createElement('a');
            overlayLink.className = 'overlay-link';
            overlayLink.href = button.href;

            // Insert after slideshow--content
            content.insertAdjacentElement('afterend', overlayLink);
        });
    });
});
document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('.section-featured-collection').forEach(section => {
        const header = section.querySelector('.section--header');
        const heading = header?.querySelector('.section--heading');
        const buttonLink = header?.querySelector('.section--btn a');

        if (!heading || !buttonLink) return;

        const link = document.createElement('a');
        link.href = buttonLink.href;
        link.className = 'section--heading-link';

        heading.parentNode.insertBefore(link, heading);
        link.appendChild(heading);
    });
});

window.addEventListener('load', () => {
  const removeTooltips = () => {
    document.querySelectorAll('.variant--item[title]').forEach((item) => {
      item.removeAttribute('title');
    });
  };

  removeTooltips();

  new MutationObserver(removeTooltips).observe(document.body, {
    childList: true,
    subtree: true
  });
});
document.addEventListener('DOMContentLoaded', function () {
  const isMobile = /Android|iPhone|iPad|iPod/i.test(navigator.userAgent);

  if (!isMobile) {
    document.querySelectorAll('.footer--menu-link[href^="tel:"]').forEach(function (link) {
      link.removeAttribute('href');
    });
  }
});

/*
##### Remove OFF text in discount badges #####
~/snippets/badges.liquid
{% comment %} {% assign offText = 'OFF' %} {% endcomment %}
{% assign offText = '' %}

##### Custom Announcement Bar #####
~/sections/announcement-bar.liquid
<swiper-content data-resize="false">
  <div
    class="announcement-bar--slide-outer{% if isBlockSize %} swiper{% endif %}"
    {% if isBlockSize %}
      data-swiper='
        {
          {% comment %} "loop": true,
          "centeredSlides": true,
          "speed": 800,
          "slidesPerView": 1,
          {% if section.settings.auto_rotate %}
          "autoplay":  {
            "delay": {{ section.settings.change_slides_speed | times: 1000 }}
          },
          {% endif %}
          "grabCursor": true {% endcomment %}
          "slidesPerView": "auto",
          "spaceBetween": 0,
          "loop": true,
          "speed": 6000,
          "allowTouchMove": false,
          "centerInsufficientSlides": true,
          "autoplay": {
            "delay": 0,
            "disableOnInteraction": false
          }
        }
      '
    {% endif %}
  >
{% endif %}
<div class="announcement-bar--slide-wrapper{% if isBlockSize %} swiper-wrapper is-slider{% endif %}">
{{ announcement_headings }}
{{ announcement_headings }}
{{ announcement_headings }}
{{ announcement_headings }}
{{ announcement_headings }}
{{ announcement_headings }}
</div>
{% if isBlockSize %}
</div>
</swiper-content>
*/
function watchMegaMenuActive() {
  const megaMenus = document.querySelectorAll('.megamenu');
  if (!megaMenus.length) return;

  const updateHeaderState = (header) => {
    const hasActiveMega = header.querySelector('.megamenu.active');
    header.classList.toggle('header-active', !!hasActiveMega);
  };

  const observer = new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
      if (
        mutation.type === 'attributes' &&
        mutation.attributeName === 'class'
      ) {
        const mega = mutation.target;
        const header = mega.closest('.header');
        if (!header) return;

        updateHeaderState(header);
      }
    });
  });

  megaMenus.forEach((menu) => {
    observer.observe(menu, {
      attributes: true,
      attributeFilter: ['class'],
    });
  });

  // Initial sync (important!)
  document.querySelectorAll('.header').forEach(updateHeaderState);
}

function prodButtonWrapper() {
  const container = document.querySelector('.product-info-details');
  if (!container) return;

  const quantity = container.querySelector('.quantity-main-product');
  const accordion = container.querySelector('.product--detail-accordion');

  if (!quantity || !accordion) return;

  // create wrapper
  const wrapper = document.createElement('div');
  wrapper.className = 'button-wrapper';

  // collect nodes between quantity and accordion
  let node = quantity.nextSibling;
  while (node && node !== accordion) {
    const next = node.nextSibling;
    wrapper.appendChild(node);
    node = next;
  }

  // insert wrapper after quantity
  quantity.after(wrapper);
}

function forceSwiperHorizontal() {
  const el = document.querySelector('.main--product-thumbnail-outer.swiper');
  if (!el || !el.swiper) return false;

  const swiper = el.swiper;

  swiper.changeDirection('horizontal', false); // false = don't reset index

  // 🔧 critical fixes
  swiper.updateSize();
  swiper.updateSlides();
  swiper.updateProgress();
  swiper.updateSlidesClasses();
  swiper.update();

  return true;
}
function forceSwiperMain() {
  const el = document.querySelector('.main--product-image-slider-outer.swiper');
  if (!el || !el.swiper) return false;

  const swiper = el.swiper;
  console.log(el.swiper);
  

  swiper.params.slidesPerView = 1;
  swiper.params.autoHight = true;
  swiper.originalParams.slidesPerView = 1;

  // 🔧 critical fixes
  swiper.updateSize();
  swiper.updateSlides();
  swiper.updateProgress();
  swiper.updateSlidesClasses();
  swiper.update();

  return true;
}
function groupItems(container, itemClass, groupClass) {
  // already wrapped → skip
  if (container.querySelector(`.${groupClass}`)) return;

  const items = Array.from(container.children).filter(el =>
    el.classList.contains(itemClass)
  );

  // no items → do nothing
  if (!items.length) return;

  const wrapper = document.createElement('div');
  wrapper.className = groupClass;

  // insert wrapper at first item position
  container.insertBefore(wrapper, items[0]);

  // move items into wrapper
  items.forEach(el => wrapper.appendChild(el));
}

document.addEventListener('DOMContentLoaded', function () {
  prodButtonWrapper();
   document.querySelectorAll('.header--menu-megamenu-columns').forEach(container => {
    groupItems(container, 'navmenu-option', 'navmenu-option-group');
    groupItems(container, 'images-option', 'images-option-group');
  });
});

window.addEventListener('load', function () {
  watchMegaMenuActive();
  forceSwiperHorizontal();
  forceSwiperMain();
});

const observer = new MutationObserver(() => {
    const form = document.querySelector('shopify-forms-embed');

    if (!form?.shadowRoot) return;

    observer.disconnect();

    const style = document.createElement('style');

    style.textContent = `
      #form-container-ref form{
        gap: 1rem;
      }
      #form-container-ref button[class^="_formSubmitButton"]{
          border-radius: 20px;
      }
      #form-container-ref input,
      #form-container-ref button[class^="_selectToggle"]{
          display: flex;
          justify-content:flex-start;
          align-items:center;
          background-color: #fff;
          color: #000;
          padding: 0px 15px;
          border-radius: 20px;
          background-color: rgba(0, 0, 0, 0);
          min-height: unset;
          height: 44px;
          box-shadow: none;
          border: 1px solid #000;
      }
      #form-container-ref input + label{
          transform: translateY(-50%);
          top: 50% !important;
      }
      #form-container-ref input:focus-within + label{
          transform: translateY(-50%);
          top: 50% !important;
      }
      label[class*="_inputFilled_"]{
          opacity: 0 !important;
      }
    `;

    form.shadowRoot.appendChild(style);
});

observer.observe(document.body, {
    childList: true,
    subtree: true
});